import React, { useState } from "react";
import { LuFileEdit as Edit, LuEye as Eye } from "react-icons/lu";
import { CreatePostForm } from "../components/create-post/form";
export const CreatePost = () => {
  const [previewMode, setPreviewMode] = useState(false);

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-xl shadow-lg border border-gray-200">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Create New Post</h2>
        <div className="flex items-center space-x-3">
          <button
            type="button"
            onClick={() => setPreviewMode(!previewMode)}
            className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
              previewMode
                ? "bg-blue-100 text-blue-700 border border-blue-300"
                : "bg-gray-100 text-gray-700 border border-gray-300"
            }`}
          >
            {previewMode ? <Edit size={18} /> : <Eye size={18} />}
            <span>{previewMode ? "Edit" : "Preview"}</span>
          </button>
        </div>
      </div>
      <CreatePostForm previewMode={previewMode} />
    </div>
  );
};
